import React, { FC, useContext, useState } from 'react';

export const NotificationsDrawerContext =
  React.createContext<{
    visibility: boolean;
    setVisibility: (any) => void;
  } | null>(null);

export const useNotificationsDrawerContext = () => {
  const context = useContext(NotificationsDrawerContext);

  if (!context) {
    throw new Error('No data available');
  }

  return context;
};

export const NotificationsDrawerContextProvider: FC = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  return (
    <NotificationsDrawerContext.Provider value={{ visibility, setVisibility }}>
      {children}
    </NotificationsDrawerContext.Provider>
  );
};
